<template>
    <SimpleTextPopup
    :title="$t('uploadPackageDimensions')"
    v-model="isShow"
    @popupClose="close" 
    :rightMethod="confirmExcelData"  
    :rightButtonText="$t('ok')"
    :rightButtonDisabled="!sheetData.length>0"
    medium
   >
    <template v-slot:input>

     <v-btn color="primary" class="upload-file" title="$t('uploadPackageDimensions')" :loading="loading" >
        <v-icon dark left>cloud_upload</v-icon>
        {{ $t('upload') }}
        <input type="file" ref="file" @change="processFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
      </v-btn>
      <v-btn color="primary" flat @click.stop="downloadTemplate">
        <v-icon dark large class="mx-2">cloud_download</v-icon>
        {{ $t('downloadTemplate') }}
      </v-btn>
      <v-layout sm12 md12>
        <v-progress-linear></v-progress-linear>
      </v-layout>
      
    <div class="status-area" >
      <v-layout v-if="!isVerified" align-start justify-center row fill-height class="subheading">
        <v-flex sm1>{{ $t('result') }}:</v-flex>
        <v-flex :style="statusColor">{{ result }}</v-flex>
      </v-layout>
      <v-data-table v-if="isVerified"
      :headers="headers"
      :items="sheetData"
      class="my-1 levation-2 myDense"
      hide-actions
      >
      <template v-slot:items="props">
        <td class="subheading">{{ props.index + 1}}</td>
        <td class="text-xs-left">{{ props.item.Quantity }}</td>
        <td class="text-xs-left">{{ props.item.Weight }}</td>
        <td class="text-xs-left">{{ props.item.Length }}</td>
        <td class="text-xs-left">{{ props.item.Width }}</td>
        <td class="text-xs-left">{{ props.item.Height }}</td>
        <td class="text-xs-left">{{ props.item.DeclaredValue }}</td>
        <td class="text-xs-left">{{ props.item.Memo }}</td>
      </template>
    </v-data-table>
    </div>
    </template>
  </SimpleTextPopup>
</template>

<script>
import xlsxHelper from 'xlsx'
import SimpleTextPopup from './SimpleTextPopup'

export default {
  name: 'ImportPackagesDimensions',
  components: {SimpleTextPopup},
  data () {
    return {
      disabled: true,
      fileData: null,
      isVerified: true,
      loading: false,
      result: '',
      sheetData: [],
      headers: [
        { text: '#', value: 'index', align: 'left', sortable: false },
        { text: this.$t('quantity'), value: 'Quantity', align: 'left', sortable: false },
        { text: this.$t('weight'), value: 'Weight', align: 'left', sortable: false },
        { text: this.$t('length'), value: 'Length', align: 'left', sortable: false },
        { text: this.$t('width'), value: 'Width', align: 'left', sortable: false },
        { text: this.$t('height'), value: 'Height', align: 'left', sortable: false },
        {
          text: this.$t('declaredValue'),
          value: 'DeclaredValue',
          align: 'left',
          sortable: false
        },
        { text: this.$t('memo'), value: 'Memo', align: 'left', sortable: false }
      ]
    }
  },
  props: {
    isShow: Boolean
  },
  computed: {
    statusColor () {
      return this.isVerified ? '' : 'color: red;'
    }
  },
  methods: {
    confirmExcelData () {
      this.$emit('confirmMethod', this.sheetData)
    },
    close () {
      this.$emit('input', false)
      this.reset()
      this.sheetData = []
    },
    reset () {
      this.$refs.file.value = null
      this.isVerified = true
      this.loading = false
      this.result = ''
    },
    handleFileError (msg) {
      this.isVerified = false
      this.result = msg
      this.loading = false
      this.$refs.file.value = null
      return false
    },
    downloadTemplate () {
      this.$store.dispatch('downloadFile', {
        fullPath: 'templates/dimensions-template.xlsx',
        name: 'dimensions-template.xlsx'
      })
    },
    processFile () {
      if (!this.$refs.file || this.$refs.file.files.length === 0) {
        return
      }
      this.loading = true
      const selectedFile = this.$refs.file.files[0]
      if (Math.round(selectedFile.size / 1048576) > 2) {
        return this.handleFileError(
          this.$t('uploadFileTooBig', { name: selectedFile.name, fileSizeLimit: 2 })
        )
      }
      let reader = new FileReader()
      reader.onload = e => {
        let fileResult = e.target.result
        let excel = xlsxHelper.read(fileResult, { type: 'binary' })
        let sheetName = excel.SheetNames[0]
        const sheet = excel.Sheets[sheetName]
        let validateSheet = this.validateSheet(sheet)
        if (!validateSheet.isVerified) {
          return this.handleFileError(validateSheet.msg)
        }
        let sheetData = xlsxHelper.utils.sheet_to_json(sheet)
        var validateDataResult = this.validateData(sheetData)
        if (!validateDataResult.isVerified) {
          return this.handleFileError(validateDataResult.msg)
        }
        this.sheetData = sheetData
        this.loading = false
        this.reset()
      }
      reader.onerror = function () {
        this.handleFileError(this.$t('uploadErrorTryAgain'))
      }
      reader.readAsBinaryString(selectedFile)
    },
    validateData (excelData) {
      let result = { isVerified: true, msg: null }

      if (excelData.length === 0) {
        result.isVerified = false
        result.msg = this.$t('fileContentIsEmpty')
        return result
      }
      for (let aPackage of excelData) {
        for (let key of Object.keys(aPackage)) {
          if (key === 'Memo') continue
          if (key === 'DeclaredValue' && aPackage[key] !== undefined) {
            if (typeof aPackage[key] !== 'number') {
              result.isVerified = false
              result.msg = `${key} ` + this.$t('fieldIsNumber')
              return result
            }
          }
          if (aPackage[key] === undefined) {
            result.isVerified = false
            result.msg = `${key} ` + this.$t('fieldIsRequired')
            return result
          }
          if (typeof aPackage[key] !== 'number') {
            result.isVerified = false
            result.msg = `${key} ` + this.$t('fieldIsNumber')
            return result
          }
        }
      }
      result.isVerified = true
      result.msg = null
      return result
    },
    validateSheet (sheet) {
      if (
        (sheet.A1.v || '') !== 'Quantity' ||
        (sheet.B1.v || '') !== 'Weight' ||
        (sheet.C1.v || '') !== 'Length' ||
        (sheet.D1.v || '') !== 'Width' ||
        (sheet.E1.v || '') !== 'Height' ||
        (sheet.F1.v || '') !== 'DeclaredValue'
      ) {
        return { isVerified: false, msg: this.$t('abnormalTemplate') }
      }
      return { isVerified: true }
    }
  }
}

</script>

<style>
.status-area {
  min-height: 240px;
}
.upload-file input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;
    cursor: inherit;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/ImportPackagesDimensions.vue